import React, { useEffect, useState } from 'react';
import {  Button, Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import moneySaving from '../../../utils/assests/money-saving.svg';
import { AppState } from '../../../store/rootReducer';
import { useSelector } from 'react-redux';
import BackgroundTheme from '../../../Common/P2P/Header/BackgroundTheme';

const Transactions = () => {
    const { cashLedgerSummary } = useSelector(
        (state: AppState) => state.dashboard
      );
      const [sortedTransaction, setSortedTransaction] = useState<any>(null)

      useEffect(()=> {
        document.title = "stashearn - transactions"
      },[])

      useEffect(() => {
        if (cashLedgerSummary?.data?.cash_ledger?.length > 0) {
          const sorted = cashLedgerSummary?.data?.cash_ledger.sort(sortTransactionHistory);
          setSortedTransaction(sorted);
        }
    }, [cashLedgerSummary]);

    const sortTransactionHistory = (a: any, b: any) => {
        if (b.transaction_date < a.transaction_date) {
          return 1;
        }
        if (b.date > a.date) {
          return -1;
        }
        return 0;
      }

  return (
      <>
   <BackgroundTheme>
   <Box sx={{ mb: '16px' }}>
        <Typography variant='h3' className='recentTransactions'>
          recent transactions
        </Typography>
      </Box>
  
    {sortedTransaction && sortedTransaction?.length > 0 ?
      sortedTransaction.map((item: any) => {
        return (
          <Box className='portfoliBottomBox'>
            <div className='row-one'>
              <div className='rupee'>₹</div>
              <div className='price'>
                {item.amount
                  .toFixed(0)
                  .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}
              </div>
              <div className='date'>{item.transaction_date}</div>
            </div>
            <div className='row-one'>
              <div className='rupee'>
                <img src={moneySaving} alt='' />
              </div>
              <div className='invested'>{item.transaction_type}</div>
              <div className='success'><span>{'transaction id'}</span> - <span >{item.transaction_id}</span></div>
            </div>
            <hr />
          </Box>
        );
      }) : 'No transaction history'}
  </BackgroundTheme>
  </>
  )
}

export default Transactions